import React from "react";
import { Box, Grid, List, ListItem, Paper } from "@mui/material";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const Title = styled.h2``;

const ContentTitle = styled.span`
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.palette.primary.main};
    margin: 0;
`;

const changes = [
    {
        title: "Update: 16 of January 2025",
        content: (
            <List sx={{ listStyleType: "disc", padding: "16px" }}>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Customization Improvements on Issues Lead Time</ContentTitle>
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            We have added an extra customization to our Issues Lead Time
                            calculations. to allow to select whether you regard as the end of a
                            ticket&apos;s life the moment when the 1st move into the
                            &quot;Done&quot; category is performed or when the last such move
                            occurs. We have made the default being the 1st one as we found that
                            followed a better process for the tickets. However, it is always able to
                            be customized per case. We have also ensured that the In Progress state
                            detection ignores any states that were then followed by a move back to
                            To Do for this ticket. Similarly for the Done state, to be taken into
                            account the ticket should not have a move back to In Progress later in
                            time. We also changed the beginning of the in porgress time to be the
                            greatest between the first moe of the ticket into In Progress state and
                            the fist issue assignment to a user.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Issue states duration chart updates</ContentTitle>
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            We decided to remove the &quot;sum&quot; aggregation for this chart and
                            replace it with a median aggregation as this one brings more clear view
                            of the states. We also added in all states in brackets the category of
                            the state so you are aware which one it belongs to
                        </ListItem>
                    </List>
                </ListItem>
            </List>
        ),
    },
    {
        title: "Update: 3rd of October 2024",
        content: (
            <List sx={{ listStyleType: "disc", padding: "16px" }}>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>
                        Collaboration days, Balance days, Long Hours, Out Of Hours and Available
                        Focus Time
                    </ContentTitle>
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            We have ensured that for all user events that are &quot;enclosed&quot;
                            within others of the same user (eg slack messages sent while the user is
                            in a meeting) the smaller &quot;enclosed&quot; events are discarded so
                            as to ensure no duplicate time is measured.
                        </ListItem>
                    </List>
                </ListItem>
            </List>
        ),
    },
    {
        title: "Update: 30th of September 2024",
        content: (
            <List sx={{ listStyleType: "disc", padding: "16px" }}>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Out Of Hours</ContentTitle>
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            &quot;Out of hours communications&quot; has been renamed to &quot;Out of
                            hours working&quot; to better depict the effect of the following
                            changes.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Long Hours and Out Of Hours: </ContentTitle>We have made
                    significant improvements in the calculation of both metrics:
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            Now it includes as many git user events as possible (PR open, closed,
                            merged, left comment, committed code) in order to more accurately depict
                            the users activity over the period.
                        </ListItem>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            Each of the users individual timezones are individually taken into
                            account when calculating the above metrics (as opposed to using the
                            viewing user&apos;s timezone for everyone).
                        </ListItem>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            Since more events are used to calculate the long working hours, we have
                            reduced the inactivity threshold when aggregating events for long hours
                            to 30 minutes.
                        </ListItem>
                    </List>
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Long Hours</ContentTitle>
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            Since more events are used to calculate the long working hours, we have
                            reduced the inactivity threshold when aggregating events for long hours
                            to 30 minutes.
                        </ListItem>
                    </List>
                </ListItem>
            </List>
        ),
    },
    {
        title: "Update: 19th of September 2024",
        content: (
            <List sx={{ listStyleType: "disc", padding: "16px" }}>
                <ListItem sx={{ display: "list-item" }}>
                    <ContentTitle>Wellbeing Long Hours: </ContentTitle>Following your feedback, we
                    improved long hours calculations to be more sensitive and to be easier to see
                    patterns. The changes introduced are:
                    <List sx={{ listStyleType: "decimal" }}>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            The threshold for above how many hours the system starting counting long
                            working hours has been changed from 9 hours in one day to 7 hours a day.
                            This will cause teams to have more elevated long hours, but will be
                            easier to pinpoint patterns of increasing work hours earlier.
                        </ListItem>
                        <ListItem sx={{ display: "list-item", fontWeight: "200" }}>
                            Any time spent during off days (eg weekend) was fully counted as long
                            hours. This seemed to contribute more into the noise level of that
                            chart. This has been altered so the days off work as any other day with
                            respect to this chart. You still will be seeing these off-days work as
                            out of hours same as before.
                        </ListItem>
                    </List>
                </ListItem>
            </List>
        ),
    },
];

const Changelog = () => {
    const renderChanges = () => {
        return (
            <>
                {changes.map((change) => (
                    <Paper
                        style={{
                            width: "100%",
                            maxWidth: "850px",
                            padding: "20px",
                            borderRadius: "14px",
                            marginBottom: "20px",
                        }}
                    >
                        <Title>{change.title}</Title>
                        {change.content}
                    </Paper>
                ))}
            </>
        );
    };

    return (
        <>
            <Helmet>
                <title>Adadot - Changelog</title>
            </Helmet>
            <Box width="100%" maxWidth="576px" marginTop="4vh" marginBottom="4vh">
                <Grid
                    container
                    spacing={5}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                >
                    <>{renderChanges()}</>
                </Grid>
            </Box>
        </>
    );
};

export default Changelog;
